import { Environment } from 'models/environment';
import { Policy } from 'policies/domain/policy';
import { apiRequest, EmbedAuth, getApiHost, getBasePathname } from 'shared/api';

interface Params {
  policyId: string;
  organizationId: string;
  environment: Environment;
  auth: EmbedAuth;
  startDate: string;
  billingDay: number | undefined;
  billingMonth: number | undefined;
}

export const movePolicyStartDate = async (params: Params) => {
  const { auth, organizationId, policyId, environment, startDate, billingDay, billingMonth } = params;

  const body: Record<string, string | number> = { start_date: startDate };
  if (billingDay !== undefined) body.billing_day = billingDay;
  if (billingMonth !== undefined) body.billing_month = billingMonth;

  const basePathName = getBasePathname({
    organizationId,
    auth,
    clientAppAuth: true,
  });

  const response = await apiRequest({
    url: `${getApiHost({ environment })}${basePathName}/policies/${policyId}`,
    method: 'patch',
    auth,
    body,
  });

  const networkPolicy = await response.json();
  const policy = Policy.fromNetwork(networkPolicy);

  return policy;
};
